// import 'core-js/features/object/from-entries';
// import 'core-js/features/array/flat';

import './styles.css';

import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import Editor from "./editor"
import { ToolbarContext } from './plugins/ToolbarContext';

type Options = {
  editorContainerElement: HTMLElement,
  onAutoSave?: (content: string) => void,
  onUpdate?: (content: string) => void,
  editorType: 'none' | 'basic',
  showEquationEditorButton?: boolean,
  initialData?: string,
  equationEditorContainerElement?: HTMLElement
}

class ErrorBoundary extends Component {
	constructor() {
		super();
		this.state = { errored: false };
	}

	static getDerivedStateFromError(error) {
		return { errored: true };
	}

	componentDidCatch(error, errorInfo) {
    if(window["__airbrakeClient"]) {
      window["__airbrakeClient"].notify({error, params: { errorInfo }});
    }
	}

	render(props, state) {
		if (state.errored) {
			return <h3>Something went wrong with your essay editor. Your work should be saved up to this point. Please try reloading the page, and if the issue persists, notify your teacher. <button onClick={() => window.location.reload()}>Reload</button></h3>;
		}
		return props.children;
	}
}

export default class EssayEditor {
  options: Options;
  editorHandleRef: React.RefObject<{getCurrentContent: () => string | undefined}>;
  constructor(options: Options) {
    this.options = options;
    const millisecondsSinceEpoch = Date.now();
    this.editorHandleRef = React.createRef();

    ReactDOM.createRoot(options.editorContainerElement).render(
      <React.StrictMode>
        <ErrorBoundary>
          <ToolbarContext>
            <Editor id={millisecondsSinceEpoch.toString()} type={options.editorType} ref={this.editorHandleRef} showEquationEditorButton={options.showEquationEditorButton || false} equationEditorContainerElement={options.equationEditorContainerElement} onAutosave={(content) => { options.onAutoSave ? options.onAutoSave(content) : null }} onChange={(content) => { options.onUpdate ? options.onUpdate(content) : null }} initialData={options.initialData} />
          </ToolbarContext>
        </ErrorBoundary>
      </React.StrictMode>,
    );
  }

  getCurrentContent() {
    if (this.editorHandleRef.current) {
      return this.editorHandleRef.current.getCurrentContent();
    }
    return undefined;
  }

  destroy() {
    ReactDOM.createRoot(this.options.editorContainerElement).render(
      null
    )
  }
}

export function EssayEditorComponent(options: {id: string} & Omit<Options, "editorContainerElement">) {
  return <ToolbarContext>
    <Editor id={options.id} type={options.editorType} showEquationEditorButton={options.showEquationEditorButton || false} equationEditorContainerElement={options.equationEditorContainerElement} onAutosave={(content) => { options.onAutoSave ? options.onAutoSave(content) : null }} onChange={(content) => { options.onUpdate ? options.onUpdate(content) : null }} initialData={options.initialData} />
  </ToolbarContext>
}